import styled from 'styled-components'
import { error } from '../../variables'

const FieldError = styled.div`
  padding-top: 5px;
  color: ${error};
  font-size: 0.8em;
`

export default FieldError
